import { AxiosError } from 'axios';
import { fileApi } from 'api/file';
import { BackendFileType } from 'api/file/params';
import { FileType } from '../types/types';

const formatFileFieldError = (event: AxiosError<{ message?: string }>, name?: string): string =>
  [name, event?.response?.data?.message || 'Произошла ошибка при загрузке файла']
    .filter(Boolean)
    .join(': ');

export const normalizeFileList = async (
  type: BackendFileType,
  fileList?: File[],
  uploadedFiles?: FileType[],
  fieldName?: string
) => {
  if (!fileList || fileList.length === 0) {
    return uploadedFiles || undefined;
  }
  try {
    const newFileList = await Promise.all(
      fileList.map(async (el) => {
        const newFile = await fileApi.uploadFile(el, type);
        return newFile;
      })
    );
    return uploadedFiles ? [...newFileList, ...uploadedFiles] : newFileList;
  } catch (e) {
    throw new Error(formatFileFieldError(e, fieldName));
  }
};

export const normalizeFile = async (
  type: BackendFileType,
  file?: File[],
  uploadedFiles?: FileType[],
  fieldName?: string
): Promise<FileType | undefined> => {
  if (!file || file.length === 0) {
    return uploadedFiles ? uploadedFiles[0] : undefined;
  }
  try {
    return await fileApi.uploadFile(file[0], type);
  } catch (e) {
    throw new Error(formatFileFieldError(e, fieldName));
  }
};
